<script setup lang="ts">
// Modal de detalhe de conquista do Minha Conta V2 (ENG-362, crit. 11) — mesmo
// shell visual do RewardRedeemModal.vue (bottom sheet no mobile, card
// centralizado no desktop, selo flutuando sobre a borda), só sem o CTA de
// resgate: aqui o botão é claimed/cta do CRM (Smartico), não "Resgatar
// recompensa". Aberto pelo estado global de useUserV2Achievements (dashboard
// e tela Conquistas compartilham o mesmo modal, renderizado uma vez no Shell).
// Badge é do CRM: não tem "resgate" nosso — quando bloqueado, o botão dispara
// a ação sugerida (cta_action/cta_text, ex. "Fazer depósito").
const { selected, closeDetail, runCta } = useUserV2Achievements();

// trava o scroll de fundo enquanto o modal está aberto — mesmo composable
// contador do Modal.vue (useBodyScrollLock)
useBodyScrollLock(computed(() => !!selected.value));
</script>

<template>
  <Teleport to="body">
    <div
      v-if="selected"
      class="user-v2-achievement-modal fixed inset-0 z-[100] flex items-end justify-center font-sans lg:items-center lg:p-[16px]"
      @dragstart.prevent
    >
      <!-- clique fora cai neste backdrop (cobre o wrapper), não no wrapper —
           @click.self no pai nunca disparava -->
      <div
        class="modal-backdrop absolute inset-0 bg-black/70"
        @click="closeDetail"
      />

      <!-- mobile: bottom sheet full-width, cantos só no topo; desktop: card
           centralizado com cantos nos 4 lados (mesmo shell do
           RewardRedeemModal.vue). -->
      <div
        class="modal-card relative flex w-full flex-col items-center gap-[24px] rounded-t-[20px] bg-v2-background px-[16px] pb-[40px] pt-[104px] text-center lg:max-w-[560px] lg:rounded-[20px] lg:pb-[24px]"
      >
        <UserV2ModalCloseButton @close="closeDetail" />

        <!-- selo flutuando por cima da borda superior do card, igual ao
             RewardRedeemModal.vue (círculo 160px, metade pra fora/metade pra
             dentro) -->
        <div
          class="absolute left-1/2 top-[-80px] flex size-[160px] -translate-x-1/2 items-center justify-center overflow-hidden rounded-full border border-v2-default-300 bg-v2-default-200"
        >
          <img
            alt=""
            class="size-[100px] rounded-[11px] object-contain"
            :src="selected.icon"
          />
        </div>

        <div class="flex flex-col gap-[6px]">
          <p class="text-[18px] font-bold leading-[28px] text-white">
            {{ selected.name }}
          </p>

          <span
            v-if="selected.reward"
            class="mx-auto rounded-[8px] bg-v2-success/20 px-[10px] py-[4px] text-[12px] font-bold leading-[16px] text-v2-success"
          >
            {{ selected.reward }}
          </span>

          <p class="text-[14px] leading-[20px] text-v2-muted">
            {{ selected.description }}
          </p>
        </div>

        <button
          v-if="selected.claimed"
          class="flex h-[40px] w-full cursor-not-allowed items-center justify-center gap-[8px] rounded-[12px] bg-v2-default-300 text-[14px] font-medium leading-[20px] text-white/40"
          disabled
          type="button"
        >
          <svg
            class="size-[16px]"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
          >
            <path d="m4 12 5 5L20 6" />
          </svg>
          Conquista desbloqueada
        </button>

        <!-- ainda bloqueada: o CRM sugere a ação pra desbloquear -->
        <button
          v-else-if="selected.ctaAction && selected.ctaText"
          class="flex h-[40px] w-full items-center justify-center gap-[8px] rounded-[12px] bg-v2-primary text-[14px] font-medium leading-[20px] text-v2-primary-foreground"
          type="button"
          @click="runCta"
        >
          {{ selected.ctaText }}
        </button>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
// main.scss reseta `transition` no app inteiro — animação de entrada via
// @keyframes/animation (mesma estratégia do RewardRedeemModal.vue).
.modal-backdrop {
  animation: achievement-fade 0.18s ease-out;
}

.modal-card {
  animation: achievement-pop 0.2s ease-out;

  // mobile: sheet sobe da borda inferior (bate com o items-end do
  // container); desktop mantém o pop com scale do card centralizado.
  @media (max-width: 1023px) {
    animation-name: achievement-slide-up;
  }
}

@keyframes achievement-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes achievement-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes achievement-slide-up {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
